// Copyright (c) 2019 Deere & Company

import { combineReducers } from 'redux';
import oktaState from './okta-state';

export const getCombinedReducers = () => combineReducers( {
    oktaState
} );
